import { TripAPI } from '../../../api/datamanager/TripAPI';

export class TripsCommand {
    getIntervals(edition, tripId, successCallback, errorCallback) {
        const apiResult = TripAPI.getIntervals(edition.network, edition.planning, tripId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getNotes(edition, tripId, successCallback, errorCallback) {
        const apiResult = TripAPI.getNotes(edition.network, edition.planning, tripId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    moveTrip(sched, tripId, networkEdition, planningEdition, successCallback, errorCallback) {
        const apiResult = TripAPI.moveTrip(sched, tripId, networkEdition, planningEdition);

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    copyTrip(sched, tripId, networkEdition, planningEdition, successCallback, errorCallback) {
        const apiResult = TripAPI.copyTrip(sched, tripId, networkEdition, planningEdition);

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    count(edition, providerId, successCallback, errorCallback) {
        const apiResult = TripAPI.countActive(edition.network, edition.planning, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveIntervals(edition, tripId, intervals, successCallback, errorCallback) {
        const apiResult = TripAPI.saveIntervals(edition.network, edition.planning, tripId, intervals);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Periodos de Funcionamento guardados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveNotes(edition, tripId, notes, successCallback, errorCallback) {
        const apiResult = TripAPI.saveNotes(edition.network, edition.planning, tripId, notes);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Notas guardadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
